import {api} from "../api.slice";
import {apiEndpoints} from "@/utils/api-endpoints";
import {INotification, SubscriptionDto} from "@/types/general";


const notificationApi = api.injectEndpoints({
    overrideExisting: true,

    endpoints: (builder) => ({
        getNotification: builder.query<INotification[], { isAll: boolean }>({
            query: ({isAll}) => ({
                url: apiEndpoints.Notification.GetNotifications.url,
                method: apiEndpoints.Notification.GetNotifications.method,
                params: {isAll},
            }),
            providesTags: ["Notifications"],
        }),

        viewNotification: builder.mutation<void, { notificationId: number }>({
            query: ({notificationId}) => ({
                url: apiEndpoints.Notification.ViewNotification.url(
                    notificationId.toString()
                ),
                method: apiEndpoints.Notification.ViewNotification.method,
            }),
            invalidatesTags: ["Notifications"],
        }),

        addSubscription: builder.mutation<void, SubscriptionDto>({
            query: (data) => ({
                url: apiEndpoints.Notification.AddSubscription.url,
                method: apiEndpoints.Notification.AddSubscription.method,
                body: data,
            }),
        }),

        removeSubscription: builder.mutation<void, SubscriptionDto>({
            query: (data) => ({
                url: apiEndpoints.Notification.RemoveSubscription.url,
                method: apiEndpoints.Notification.RemoveSubscription.method,
                body: data,
            }),
        }),

        deleteNotification: builder.mutation<void, { notificationId: number }>({
            query: ({ notificationId }) => ({
                url: apiEndpoints.Notification.DeleteNotification.url(notificationId.toString()),
                method: apiEndpoints.Notification.DeleteNotification.method,
            }),
            invalidatesTags: ["Notifications"],
        }),

    }),
});

export const {
    useGetNotificationQuery,
    useViewNotificationMutation,
    useAddSubscriptionMutation,
    useRemoveSubscriptionMutation,
    useDeleteNotificationMutation,
} = notificationApi;

export {notificationApi};
